import { api } from '@api'

import { CarrierUpdateData } from '../../types'

interface UpdateCarrierResponse {
  message: string
}

const updateCarrier = async (carrierId: number, data: CarrierUpdateData) => {
  const carrierData = {
    carrier: {
      address: data.address,
      businessName: data.businessName,
      cellphone: data.cellphone,
      country: data.country,
      email: data.email,
      password: data.password,
      phone: data.phone,
      sapId: data.sapId,
      tradeName: data.tradeName,
      disabled: data.disabled,
    },
  }
  const response = await api.put<UpdateCarrierResponse>(`/carriers/${carrierId}`, carrierData)

  return response.data.message
}

export const CarriersApi = {
  updateCarrier,
}
